<template>
  <section>
    <b-loading :is-full-page="true" :active="isLoading" :can-cancel="false"></b-loading>
    <b-notification
      v-model="isError"
      indefinite="true"
      type="is-danger"
      role="alert"
      :message="error"
      :closable="false"
    ></b-notification>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AuthEngine from '@/plugins/msal'
import * as Sentry from '@sentry/browser'

export default defineComponent({
  name: 'AuthCallback',
  setup() {
    // Composables
    const route = useRoute()
    const router = useRouter()
    const { t } = useI18n()

    // Reactive state
    const isLoading = ref(true)
    const error = ref('')

    // Computed
    const isError = computed(() => error.value.length > 0)

    // Lifecycle
    onMounted(async () => {
      const { token, memberId, t: tokenParam, m: memberIdParam } = route.query
      
      // Handle query parameter fallbacks
      const finalToken = String(token || tokenParam || '')
      const finalMemberId = String(memberId || memberIdParam || '')
      
      if (
        !finalToken &&
        !finalMemberId &&
        AuthEngine.isAuthenticated()
      ) {
        await router.push('/')
        return
      }

      try {
        const authResult = await AuthEngine.handleAuthentication(
          finalToken || undefined, 
          finalMemberId || undefined
        )
        
        Sentry.setUser({ 
          username: authResult.memberId || authResult.idTokenPayload 
        })
        
        // Note: AuthResult from msal.ts doesn't have appState, so we'll navigate to /shops
        await router.push('/shops')
      } catch (e) {
        isLoading.value = false
        error.value = t('AuthGeneralError')
        Sentry.captureException(e)
      }
    })

    return {
      isLoading,
      error,
      isError
    }
  }
})
</script>

<style>
.spinner {
  position: absolute;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.media-content {
  text-align: center;
}
</style>
